<template>
  <div class="topbar-item">
    <div
      class="position-relative btn btn-icon btn-sm btn-clean btn-text-dark-75 quick-toggle-btn"
      id="kt_quick_notifications_toggle"
      @click="toggleCanvas"
      data-test="cart-topbar"
    >
      <div
        v-if="!isCartEmpty"
        class="position-absolute cart-badge cirx-custom-primary-color-bg d-flex justify-content-center align-items-end"
      >
        <span class="font-weight-bold text-white cart-number">
          {{ getCartBuybacksLength }}
        </span>
      </div>

      <span class="svg-icon svg-icon-xl">
        <inline-svg src="/media/svg/icons/Shopping/Cart1.svg" />
      </span>
    </div>

    <div
      id="kt_quick_notifications"
      ref="kt_quick_notifications"
      class="offcanvas offcanvas-right"
      data-test="quick-cart"
      :class="{ 'offcanvas-on': isCanvasOn }"
    >
      <div class="offcanvas-header d-flex align-items-center justify-content-between m-10">
        <h3 class="font-weight-bold m-0">
          {{ translate("CART.QUICK_CART.TITLE") }}
          <small class="text-muted font-size-sm ml-2">
            {{
              translateWithPluralization("CART.QUICK_CART.CONTENT", cart.cartBuybacks.length, {
                productNb: cart.cartBuybacks.length,
              })
            }}
          </small>
        </h3>

        <a class="btn btn-xs btn-icon btn-light btn-hover-primary" id="quick_notifications_close" @click="closeCanvas">
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>

      <div v-if="!isCartEmpty">
        <div v-if="!cart.isMinimumCartValueReached()">
          <hr class="w-100 mb-0" />

          <div class="design-system m-10">
            <CartAlert @addAnotherProductToCart="addAnotherProductToCart" />
          </div>
        </div>

        <hr class="w-100 mb-0" />

        <div class="cart-total-subheader d-flex justify-content-between align-items-center px-10 design-system">
          <div>
            <h6>
              {{ translateWithPluralization("CART.CARD.TOTAL_BUYBACK_PRICE", getCartBuybacksLength) }}
            </h6>

            <p
              id="gtm-card-price-value"
              data-test="sidebar-card-total"
              class="priceValue cirx-custom-primary-color font-weight-bold m-0"
            >
              {{ localizeCurrency(getCartTotal) }}
            </p>
          </div>

          <BrandedButton
            @click="closePanelAndGoToCart()"
            data-test="close-panel"
            :disabled="!cart.isMinimumCartValueReached()"
          >
            {{ translate("CART.QUICK_CART.GO_TO_CART") }}
          </BrandedButton>
        </div>
      </div>

      <hr class="w-100 m-0" />

      <PerfectScrollbar style="max-height: 90vh">
        <div v-if="!isCartEmpty" data-test="quick-cart-content" class="offcanvas-content m-0 mx-10 cart-content">
          <div class="navi navi-icon-circle navi-spacer-x-0">
            <CartItem
              v-for="(cartBuyback, index) in cart.cartBuybacks"
              :key="cartBuyback.inCartId"
              :cartBuyback="cartBuyback"
              :index="index"
            />
          </div>
        </div>
      </PerfectScrollbar>
    </div>
    <div class="offcanvas-overlay" v-if="isCanvasOn" @click="closeCanvas"></div>
  </div>
</template>

<script>
import BrandedButton from "@/apps/shared/buyback/view/components/Button/BrandedButton.vue";
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import CartItem from "@/apps/shared/buyback/view/components/Cart/CartItem.vue";
import useTranslate from "@/core/composables/translate";
import { useCartStore } from "@/core/store/cart/cartStore";
import { computed } from "vue";
import { storeToRefs } from "pinia";
import CartAlert from "@/view/components/Shared/CartAlert.vue";
import { routes } from "@/routing/routes.js";

export default {
  name: "QuickCart",

  components: {
    BrandedButton,
    CartAlert,
    CartItem,
    PerfectScrollbar,
  },

  data() {
    return {
      isCanvasOn: false,
    };
  },

  setup() {
    const { translate, localizeCurrency, translateWithPluralization } = useTranslate();
    const { getCartTotal, isCartEmpty, cart } = storeToRefs(useCartStore());
    const getCartBuybacksLength = computed(() => cart.value.cartBuybacks.length);
    return {
      getCartTotal,
      isCartEmpty,
      getCartBuybacksLength,
      cart,
      translate,
      localizeCurrency,
      translateWithPluralization,
    };
  },

  methods: {
    closeCanvas() {
      this.isCanvasOn = false;
    },
    toggleCanvas() {
      this.isCanvasOn = !this.isCanvasOn;
    },
    closePanelAndGoToCart() {
      this.isCanvasOn = false;
      this.$router.push(routes.cartCustomerInformations.path);
    },
    addAnotherProductToCart() {
      if (this.$route.name !== (routes.search.name || routes.productSearchResults.name)) {
        this.$router.push(routes.productSearchResults.path);
      }
      this.closeCanvas();
    },
  },
};
</script>

<style lang="scss">
@import "vue3-perfect-scrollbar/style.css";

.ps {
  height: 100%;
}

.cart-badge {
  padding: 2px 5px;
  top: -1px;
  left: -2px;
  border-radius: 4px;
}

.cart-number {
  font-size: 9px;
}

.cart-content {
  position: initial;
  padding-bottom: 100px;
}

.cart-total-subheader {
  height: 80px;
  background: #e5eaee75;
}
</style>
